import React from 'react';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { baseTotalColumns } from '../../groups/GroupedTotalsColumn';
import { NeedsAssignedScheduleReportTable } from './NeedsAssignedTable';
import { GroupVisitsByTeamTable } from '../../groups/GroupVisitsByTeamTable';

const NeedsAssignedTeamDataTable = createQueryDataTable('schedule-report-totals-team-unassigned');
type RowType = RowOfQueryDataTable<typeof NeedsAssignedTeamDataTable>;

const columnDefinitions = NeedsAssignedTeamDataTable.columns([
	{
		header: 'Team',
		key: 'team',
		sortable: true
	},
	...baseTotalColumns<RowType>()
]);

export function NeedsAssignedTeamTable(props: PropsOfQueryDataTable<typeof NeedsAssignedTeamDataTable>) {
	return (
		<GroupVisitsByTeamTable
			columnDefinitions={columnDefinitions}
			searchType="schedule-report-totals-team-unassigned"
			tableComponent={NeedsAssignedScheduleReportTable}
			{...props}
		/>
	);
}
